import { memo } from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

const EmailConfirmedIllustration = ({ width = 251, height = 250 }) => (
  <Svg width={width} height={height} viewBox="0 0 251 250" fill="none">
    <G clipPath="url(#clip0_8483_162755)">
      <Path
        d="M143.77 191.91L148.73 243.97L169.08 192.93L177.72 171.2L210.19 89.79L153.17 99.86L129.65 103.57L125.66 53.23L121.21 6.47L100.34 58.79L92.9402 77.36L86.6902 93.04V93.06V93.04L59.7202 160.65L79.4802 157.16L139.61 146.6L143.77 191.9V191.91Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M98.3196 51.07C97.3396 52.87 96.3696 54.53 95.4196 56.12C87.8896 68.69 81.2896 74.48 75.7996 78.02C72.9096 79.87 70.3696 81.13 68.1496 82.39C68.1396 82.39 68.1396 82.4 68.1296 82.4C68.0796 82.14 68.0596 81.87 68.0296 81.59C67.9396 80.74 67.8496 80.19 67.5896 79.76C67.4996 79.61 67.3996 79.48 67.2696 79.35C67.2196 79.3 67.1696 79.25 67.1096 79.19C67.0596 79.14 66.9896 79.09 66.9196 79.04C66.7796 78.94 66.6296 78.83 66.4496 78.73C66.3796 78.68 66.2996 78.64 66.2196 78.6C66.1396 78.56 66.0596 78.51 65.9696 78.46C65.9196 78.43 65.8696 78.41 65.8196 78.38C65.7496 78.34 65.6796 78.3 65.5996 78.27C65.5296 78.24 65.4596 78.2 65.3796 78.16C65.2996 78.12 65.2196 78.08 65.1396 78.04C65.0596 77.99 64.9696 77.95 64.8796 77.91C64.8796 77.9 64.8696 77.9 64.8696 77.9H64.8496C64.6696 77.81 64.4796 77.72 64.2796 77.62C64.1296 77.55 63.9896 77.48 63.8596 77.41C63.4396 77.21 63.0796 77.05 62.7596 76.92H62.7496C62.6396 76.88 62.5396 76.84 62.4396 76.81C62.1496 76.71 61.8896 76.66 61.6596 76.66C61.5796 76.66 61.5096 76.67 61.4296 76.68C61.3596 76.69 61.2896 76.71 61.2196 76.74C61.0696 76.8 60.9296 76.88 60.7896 77C60.7296 77.05 60.6696 77.1 60.6196 77.17C60.5396 77.24 60.4796 77.32 60.4196 77.41C60.3596 77.5 60.2896 77.58 60.2196 77.69C60.1696 77.66 60.1096 77.63 60.0596 77.6C60.0096 77.57 59.9496 77.54 59.8996 77.51C59.7896 77.45 59.6796 77.38 59.5796 77.32C59.3196 77.16 59.0696 77.01 58.8196 76.86V76.84C58.6496 74.43 58.3496 71.78 58.3196 68.58V68.55C58.2996 62.04 59.5596 53.34 65.9396 40.17C65.9396 40.16 65.9496 40.16 65.9496 40.15C66.7496 38.51 67.6296 36.77 68.6096 34.99L98.3196 51.07Z"
        fill="#F3123C"
      />
      <Path
        d="M58.8196 96.17C58.7496 98.57 59.8396 100.8 62.4596 103.78L46.8996 95.36L44.1196 93.85C48.3496 94.44 50.8896 94.06 52.9296 92.42C53.1396 92.5 53.3696 92.6 53.5996 92.7C53.9096 92.83 54.2396 92.97 54.5896 93.11C54.7196 93.17 54.8596 93.22 54.9996 93.29C55.2596 93.41 55.5396 93.53 55.8296 93.66C55.9296 93.7 56.0296 93.74 56.1296 93.77C56.2196 93.79 56.2896 93.81 56.3696 93.83C56.4196 93.85 56.4696 93.85 56.5296 93.86C56.6096 93.87 56.6796 93.89 56.7496 93.89C56.8796 93.91 56.9996 93.91 57.1196 93.89C57.1796 93.9 57.2296 93.89 57.2796 93.89C57.3396 93.88 57.3996 93.87 57.4496 93.85C57.7896 93.77 58.0696 93.61 58.2896 93.39C58.3096 93.37 58.3296 93.35 58.3496 93.32C58.4996 93.17 58.6096 92.99 58.6796 92.8C58.7096 92.73 58.7296 92.65 58.7496 92.58C58.8796 92.06 58.7696 91.46 58.3296 90.96C58.2696 90.89 58.1996 90.82 58.1196 90.75C57.9596 90.61 57.7796 90.48 57.5596 90.37L57.5296 90.35C57.5296 90.35 57.4996 90.33 57.4896 90.32L57.0596 89.92C59.0596 90.87 60.4996 89.32 60.0396 87.88C60.0096 87.8 59.9796 87.71 59.9496 87.63C59.8396 87.39 59.6796 87.16 59.4496 86.95C59.3696 86.88 59.2896 86.8 59.1896 86.73C59.1896 86.73 59.1796 86.71 59.1696 86.71C59.1296 86.68 59.0896 86.66 59.0396 86.63C58.9896 86.6 58.9396 86.57 58.8896 86.54L58.8696 86.51L58.6096 86.09C59.6596 86.62 60.4696 86.32 60.9196 85.69C61.0696 85.49 61.1796 85.26 61.2496 85.01C61.3496 84.67 61.3596 84.29 61.2796 83.93C61.2396 83.78 61.1896 83.62 61.1196 83.48C61.2596 83.34 61.3996 83.2 61.5296 83.06C61.8196 82.74 62.0896 82.4 62.3396 82.05H62.3496C62.3496 82.05 62.3496 82.01 62.3696 81.99C62.4196 81.93 62.4596 81.88 62.4996 81.82C62.3696 82.01 62.2596 82.21 62.1596 82.41C62.1096 82.48 62.0796 82.55 62.0496 82.62C62.0196 82.67 61.9996 82.73 61.9796 82.78C61.9796 82.81 61.9496 82.84 61.9396 82.86C61.8796 82.99 61.8296 83.11 61.7796 83.24C61.7096 83.42 61.6496 83.59 61.5996 83.75C61.5696 83.85 61.5396 83.95 61.5096 84.04C61.4896 84.1 61.4796 84.16 61.4696 84.21C61.4396 84.32 61.4096 84.44 61.3896 84.56C61.3696 84.65 61.3496 84.74 61.3396 84.83C61.3396 84.83 61.3296 84.87 61.3296 84.88C61.3196 84.95 61.3096 85.02 61.2996 85.08C61.2996 85.09 61.2996 85.1 61.2996 85.12C61.2696 85.3 61.2496 85.49 61.2396 85.68C61.1796 86.58 61.2696 87.49 61.5096 88.36C61.5296 88.43 61.5496 88.51 61.5696 88.58C59.8996 91.7 58.8796 93.99 58.8196 96.14V96.18V96.17Z"
        fill="#404040"
      />
      <Path
        d="M43.4998 93.52L39.0298 99.36L60.6198 111.07L63.0898 104.13L43.4998 93.51V93.52Z"
        fill="#404040"
      />
      <Path
        d="M65.9696 40.19L53.6196 33.52C43.7396 51.76 52.7696 65.58 58.3496 68.6"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M95.4996 56.15L107.77 62.82C97.8796 81.06 81.3796 81.06 75.8296 78.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M98.3196 51.07C97.3396 52.87 96.3696 54.53 95.4196 56.12C87.8896 68.69 81.2896 74.48 75.7996 78.02C72.9096 79.87 70.3696 81.13 68.1496 82.39C68.1396 82.39 68.1396 82.4 68.1296 82.4C68.0796 82.14 68.0596 81.87 68.0296 81.59C67.9396 80.74 67.8496 80.19 67.5896 79.76C67.4996 79.61 67.3996 79.48 67.2696 79.35C67.2196 79.3 67.1696 79.25 67.1096 79.19C67.0596 79.14 66.9896 79.09 66.9196 79.04C66.7796 78.94 66.6296 78.83 66.4496 78.73C66.3796 78.68 66.2996 78.64 66.2196 78.6C66.1396 78.56 66.0596 78.51 65.9696 78.46C65.9196 78.43 65.8696 78.41 65.8196 78.38C65.7496 78.34 65.6796 78.3 65.5996 78.27C65.5296 78.24 65.4596 78.2 65.3796 78.16C65.2996 78.12 65.2196 78.08 65.1396 78.04C65.0596 77.99 64.9696 77.95 64.8796 77.91C64.8696 77.91 64.8596 77.91 64.8496 77.9C64.6696 77.81 64.4796 77.72 64.2796 77.62C64.1296 77.55 63.9896 77.48 63.8596 77.41C63.4396 77.21 63.0796 77.05 62.7596 76.92H62.7496C62.6396 76.88 62.5396 76.84 62.4396 76.81C62.1496 76.71 61.8896 76.66 61.6596 76.66C61.5796 76.66 61.5096 76.67 61.4296 76.68C61.3596 76.69 61.2896 76.71 61.2196 76.74C61.0696 76.8 60.9296 76.88 60.7896 77C60.7296 77.05 60.6696 77.1 60.6196 77.17C60.5396 77.24 60.4796 77.32 60.4196 77.41C60.3596 77.5 60.2896 77.58 60.2196 77.69C60.1696 77.66 60.1096 77.63 60.0596 77.6C60.0096 77.57 59.9496 77.54 59.8996 77.51C59.7896 77.45 59.6796 77.38 59.5796 77.32C59.3196 77.16 59.0696 77.01 58.8196 76.86V76.84C58.6496 74.43 58.3496 71.78 58.3196 68.58V68.55C58.2996 62.04 59.5596 53.34 65.9396 40.17C65.9396 40.16 65.9496 40.16 65.9496 40.15C66.7496 38.51 67.6296 36.77 68.6096 34.99L98.3196 51.07V51.07Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinejoin="round"
      />
      <Path
        d="M58.8196 96.17C58.7496 98.57 59.8396 100.8 62.4596 103.78L46.8996 95.36L44.1196 93.85C48.3496 94.44 50.8896 94.06 52.9296 92.42C53.1396 92.5 53.3696 92.6 53.5996 92.7C53.9096 92.83 54.2396 92.97 54.5896 93.11C54.7196 93.17 54.8596 93.22 54.9996 93.29C55.2596 93.41 55.5396 93.53 55.8296 93.66C55.9296 93.7 56.0296 93.74 56.1296 93.77C56.2196 93.79 56.2896 93.81 56.3696 93.83C56.4196 93.85 56.4696 93.85 56.5296 93.86C56.6096 93.87 56.6796 93.89 56.7496 93.89C56.8796 93.91 56.9996 93.91 57.1196 93.89C57.1796 93.9 57.2296 93.89 57.2796 93.89C57.3396 93.88 57.3996 93.87 57.4496 93.85C57.7896 93.77 58.0696 93.61 58.2896 93.39C58.3096 93.37 58.3296 93.35 58.3496 93.32C58.4996 93.17 58.6096 92.99 58.6796 92.8C58.7096 92.73 58.7296 92.65 58.7496 92.58C58.8796 92.06 58.7696 91.46 58.3296 90.96C58.2696 90.89 58.1996 90.82 58.1196 90.75C57.9596 90.61 57.7796 90.48 57.5596 90.37L57.5296 90.35C57.5296 90.35 57.4996 90.33 57.4896 90.32L57.0596 89.92C59.0596 90.87 60.4996 89.32 60.0396 87.88C60.0096 87.8 59.9796 87.71 59.9496 87.63C59.8396 87.39 59.6796 87.16 59.4496 86.95C59.3696 86.88 59.2896 86.8 59.1896 86.73C59.1896 86.73 59.1796 86.71 59.1696 86.71C59.1296 86.68 59.0896 86.66 59.0396 86.63C58.9896 86.6 58.9396 86.57 58.8896 86.54L58.8696 86.51L58.6096 86.09C59.6596 86.62 60.4696 86.32 60.9196 85.69C61.0696 85.49 61.1796 85.26 61.2496 85.01C61.3496 84.67 61.3596 84.29 61.2796 83.93C61.2496 83.78 61.1996 83.62 61.1296 83.48C61.2696 83.34 61.3996 83.2 61.5296 83.06C61.8196 82.74 62.0896 82.4 62.3396 82.05H62.3496C62.3996 81.97 62.4496 81.89 62.4996 81.82C62.5396 81.77 62.5696 81.71 62.6096 81.66C62.4496 81.9 62.2996 82.15 62.1596 82.41C62.1096 82.48 62.0796 82.55 62.0496 82.62C62.0196 82.67 61.9996 82.73 61.9796 82.78C61.9796 82.81 61.9496 82.84 61.9396 82.86C61.8796 82.99 61.8296 83.11 61.7796 83.24C61.7096 83.42 61.6496 83.59 61.5996 83.75C61.5696 83.85 61.5396 83.95 61.5096 84.04C61.4896 84.1 61.4796 84.16 61.4696 84.21C61.4396 84.32 61.4096 84.44 61.3896 84.56C61.3696 84.65 61.3496 84.74 61.3396 84.83C61.3396 84.83 61.3296 84.87 61.3296 84.88C61.3196 84.95 61.3096 85.02 61.2996 85.08C61.2996 85.09 61.2996 85.1 61.2996 85.12C61.2696 85.3 61.2496 85.49 61.2396 85.68C61.1796 86.58 61.2696 87.49 61.5096 88.36C61.5296 88.43 61.5496 88.51 61.5696 88.58C59.8996 91.7 58.8796 93.99 58.8196 96.14V96.18V96.17Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinejoin="round"
      />
      <Path
        d="M43.5198 93.52L39.0498 99.36L60.6398 111.07L63.1098 104.13L43.5198 93.51V93.52Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinejoin="round"
      />
      <Path
        d="M77.9697 58.05C78.1897 57.56 78.2797 57.01 78.2397 56.45L77.8897 51.54C77.8597 51.17 77.8897 50.8 77.9897 50.44L77.8197 50.55C76.8097 51.23 76.2397 52.4 76.3297 53.61L76.6097 57.54C76.6997 58.75 76.1297 59.92 75.1197 60.6L74.9497 60.71C75.0397 60.36 75.0797 59.99 75.0497 59.61L74.6297 53.72C74.5997 53.35 74.6297 52.98 74.7297 52.62L74.5597 52.73C73.5497 53.41 72.9797 54.57 73.0697 55.78L73.3497 59.72C73.4397 60.93 72.8697 62.1 71.8597 62.78L71.6897 62.89C71.7797 62.54 71.8197 62.17 71.7897 61.79L71.4397 56.88C71.3897 56.22 71.5397 55.58 71.8397 55.02C69.1597 54.48 66.8897 54.99 66.1497 56.51C65.1197 58.62 67.4597 61.88 71.3697 63.79C75.2797 65.7 79.2897 65.53 80.3197 63.42C81.0597 61.9 80.0597 59.79 77.9897 58.01L77.9697 58.05Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M182.68 183.35C182.69 185.45 182.49 187.48 182.02 189.19C181.97 189.37 181.92 189.55 181.86 189.73C181.75 190.09 181.62 190.42 181.49 190.74C181.47 190.78 181.46 190.81 181.44 190.85C181.44 190.86 181.43 190.88 181.42 190.89C181.04 191.74 180.55 192.46 179.97 192.98C175.93 192.98 172.31 192.97 169.08 192.95C160.02 192.89 153.91 192.75 149.58 192.47C148.51 192.4 147.55 192.33 146.68 192.25C145.82 192.17 145.05 192.09 144.35 191.99C144.21 191.98 144.07 191.96 143.94 191.93C143.84 191.92 143.75 191.9 143.65 191.89C143.48 191.87 143.32 191.84 143.17 191.81C142.96 191.77 142.76 191.73 142.56 191.7C142.53 191.7 142.49 191.7 142.46 191.68C142.23 191.63 142.01 191.58 141.79 191.54C141.72 191.53 141.65 191.51 141.58 191.49C141.44 191.45 141.31 191.42 141.18 191.39C140.39 191.19 139.69 190.96 139.02 190.7C138.69 190.58 138.37 190.44 138.05 190.3C137.65 190.13 137.24 189.95 136.82 189.75C136.74 189.71 136.66 189.67 136.58 189.62C136.49 189.57 136.4 189.51 136.31 189.46C136.14 189.35 135.97 189.22 135.79 189.08C131.55 185.68 127.64 173.81 124.25 163.48C124.26 163.47 124.27 163.46 124.27 163.45C124.42 163.27 124.59 163.08 124.77 162.88C124.87 162.77 124.97 162.66 125.07 162.54C125.17 162.43 125.28 162.31 125.39 162.19C128.44 158.8 134.09 153.06 137.15 150.12C137.16 150.11 137.17 150.1 137.18 150.09C136.65 150.34 136.11 150.59 135.57 150.85C131.75 152.64 127.61 154.4 123.44 156.09C123.33 156.13 123.23 156.17 123.13 156.21C122.76 156.36 122.39 156.51 122.02 156.66C122.02 156.66 122.013 156.663 122 156.67C121.88 156.73 121.76 156.77 121.65 156.81C118.54 158.04 115.44 159.22 112.45 160.34C111.4 160.73 110.39 161.1 109.41 161.46C109.85 162.26 110.47 163.41 111.23 164.85C111.35 165.09 111.48 165.34 111.62 165.6C111.65 165.66 111.68 165.72 111.72 165.78C111.95 166.23 112.19 166.7 112.45 167.2C113.81 169.83 115.46 173.06 117.27 176.66C117.8 177.72 118.34 178.78 118.87 179.83C119.13 180.33 119.38 180.84 119.64 181.36C120.69 183.46 121.71 185.5 122.63 187.36H122.64C122.95 187.98 123.26 188.6 123.56 189.23C123.73 189.57 123.9 189.91 124.06 190.23C124.22 190.55 124.37 190.87 124.53 191.17C124.74 191.6 124.95 192.03 125.17 192.46C125.37 192.87 125.56 193.25 125.73 193.6C125.89 193.92 126.04 194.23 126.2 194.55C125.22 197.08 123.03 199.27 120.28 200.92C120.08 201.04 119.88 201.15 119.68 201.27C119.5 201.38 119.32 201.48 119.13 201.57C119.11 201.58 119.09 201.59 119.07 201.6C119.03 201.63 118.99 201.65 118.94 201.67C118.7 201.79 118.45 201.91 118.2 202.02C118.07 202.09 117.93 202.15 117.8 202.2C117.75 202.23 117.69 202.26 117.64 202.27C117.47 202.34 117.31 202.41 117.14 202.48C116.92 202.57 116.7 202.66 116.48 202.74C115.81 202.99 115.13 203.21 114.45 203.41C111.08 204.36 107.56 204.59 104.63 203.91C103.14 201.46 101.73 199.12 100.39 196.91C98.2601 193.38 96.3001 190.14 94.5201 187.16C94.0001 186.28 93.5001 185.42 93.0001 184.59C87.5701 175.44 83.9301 168.9 81.7701 163.89C81.6701 163.67 81.5801 163.47 81.5001 163.27C79.5801 158.66 78.9801 155.39 79.4401 152.56C79.4601 152.43 79.4801 152.32 79.5001 152.2C79.5601 151.92 79.6201 151.64 79.6901 151.37C79.7501 151.17 79.8101 150.96 79.8901 150.76C79.9201 150.66 79.9501 150.56 79.9901 150.47C80.1301 150.09 80.3001 149.7 80.5101 149.32C80.6101 149.13 80.7201 148.94 80.8401 148.75C80.9001 148.66 80.9601 148.56 81.0201 148.47C81.1301 148.31 81.2401 148.14 81.3601 147.98C81.3801 147.95 81.4001 147.93 81.4201 147.9C81.5601 147.72 81.7101 147.53 81.8701 147.35C82.0301 147.15 82.2101 146.96 82.4001 146.76L82.6801 146.48C82.7701 146.39 82.8501 146.31 82.9401 146.22C83.1501 146.01 83.3801 145.8 83.6301 145.6C83.7401 145.5 83.8601 145.4 83.9801 145.3C84.0901 145.19 84.2101 145.1 84.3401 145C84.7201 144.7 85.1201 144.39 85.5501 144.08C85.7301 143.94 85.9101 143.81 86.1101 143.67C86.5301 143.39 86.9701 143.09 87.4401 142.79C89.1601 141.68 91.2301 140.49 93.7201 139.16C98.9601 136.38 106.09 133.01 115.8 128.62V128.6C115.68 127.29 115.47 125.31 115.2 122.97C116.83 121.97 118.48 121.06 120.15 120.23C120.48 120.07 120.82 119.91 121.15 119.75C121.48 119.58 121.82 119.42 122.16 119.28C122.84 118.98 123.51 118.69 124.2 118.41C124.54 118.27 124.88 118.14 125.22 118.01C125.67 117.83 126.12 117.66 126.59 117.5C127.16 117.29 127.74 117.1 128.33 116.91C128.49 116.85 128.65 116.8 128.82 116.76C129.35 116.58 129.89 116.42 130.43 116.27C130.87 116.14 131.32 116.02 131.78 115.91C132.33 115.76 132.89 115.62 133.44 115.49C133.63 115.44 133.83 115.4 134.03 115.36C134.52 115.25 135.01 115.15 135.51 115.05C135.77 114.99 136.03 114.94 136.3 114.9C136.84 114.79 137.38 114.7 137.93 114.62C137.97 114.6 138.01 114.6 138.05 114.6C138.71 114.49 139.37 114.39 140.04 114.31C140.28 114.27 140.53 114.24 140.78 114.22C142.79 113.98 144.84 113.83 146.91 113.75C147.67 113.72 148.44 113.71 149.21 113.7C153.04 120.34 154.29 126.18 153.99 131.04V131.08C153.93 131.97 153.82 132.82 153.67 133.65C153.55 134.3 153.39 134.94 153.22 135.55C153.15 135.74 153.1 135.93 153.04 136.11C152.98 136.31 152.91 136.5 152.84 136.69C152.77 136.87 152.7 137.06 152.63 137.24C152.56 137.43 152.49 137.61 152.4 137.79C152.33 137.97 152.25 138.14 152.16 138.32C152 138.67 151.83 139 151.65 139.33C151.4 139.79 151.13 140.23 150.86 140.65C150.74 140.83 150.62 141.01 150.48 141.19C150.27 141.48 150.06 141.76 149.84 142.03C149.51 142.43 149.16 142.81 148.81 143.17C148 143.99 147.14 144.7 146.26 145.26C146.26 145.27 146.25 145.27 146.25 145.27C146.23 145.28 146.21 145.29 146.19 145.3V145.32C147.25 150.89 149.86 162.71 151.49 170.18C153.92 170.4 163.92 170.66 172.62 170.99C175.28 171.09 177.82 171.2 179.99 171.32C180 171.34 180.01 171.35 180.02 171.37C181.46 173.81 182.41 177.84 182.63 181.84C182.65 182.09 182.66 182.34 182.67 182.6C182.68 182.85 182.69 183.1 182.68 183.35Z"
        fill="#F3123C"
      />
      <Path
        d="M193.85 26.86C193.85 26.86 193.84 26.9 193.84 26.92C193.83 26.99 193.8 27.05 193.78 27.12C193.75 27.18 193.71 27.24 193.66 27.3C193.61 27.37 193.55 27.44 193.47 27.51C193.11 27.87 192.44 28.22 191.39 28.53V28.5C191.38 27.85 191.37 27.13 191.38 26.39C191.38 26.01 191.39 25.62 191.39 25.21C191.51 25.18 191.68 25.19 191.87 25.22C192.01 25.25 192.14 25.28 192.27 25.32C193.05 25.58 193.94 26.17 193.85 26.86Z"
        fill="#404040"
      />
      <Path
        d="M198.69 201.69C198.29 201.59 197.89 201.47 197.49 201.33L196.95 201.15C195.75 200.72 194.51 200.18 193.27 199.56C188.34 197.12 183.5 193.45 181.5 190.77C181.64 190.44 181.76 190.09 181.86 189.73C181.92 189.55 181.97 189.37 182.02 189.19C182.44 187.55 182.66 185.57 182.68 183.5C182.69 183.15 182.68 182.79 182.66 182.44C182.64 181.06 182.51 179.66 182.29 178.3C182.26 178.03 182.21 177.76 182.15 177.5C182.08 177.03 181.98 176.57 181.86 176.12C181.81 175.89 181.75 175.67 181.69 175.44C181.6 175.11 181.5 174.78 181.4 174.47C181.28 174.11 181.16 173.77 181.02 173.44C181.02 173.42 181.01 173.4 181 173.38C181.74 173.28 182.5 173.25 183.25 173.26C183.93 173.89 184.76 174.78 185.69 175.86C186.06 176.29 186.45 176.76 186.84 177.25C187.24 177.75 187.64 178.27 188.05 178.81C188.46 179.36 188.88 179.93 189.3 180.52C191.02 182.93 192.77 185.68 194.29 188.54C195.75 191.27 197 194.08 197.79 196.76C197.89 197.11 197.98 197.45 198.07 197.79C198.24 198.46 198.38 199.13 198.49 199.78C198.59 200.43 198.66 201.07 198.69 201.69Z"
        fill="#404040"
      />
      <Path
        d="M177.97 28.8V28.84C176.39 28.45 175.63 27.88 175.46 27.36C175.44 27.28 175.43 27.21 175.43 27.13C175.43 26.05 176.97 25.73 177.41 25.73H177.43C177.96 26.66 178.16 27.74 177.97 28.8Z"
        fill="#404040"
      />
      <Path
        d="M156.48 88.55C155.92 90.41 155.18 92.92 154.39 95.7C154.38 95.73 154.37 95.76 154.37 95.78C154.28 96.06 154.2 96.34 154.12 96.63C153.82 97.69 153.51 98.77 153.19 99.85C152.99 100.57 152.78 101.29 152.58 102C152.35 102.8 152.12 103.59 151.9 104.38C151.79 104.74 151.69 105.1 151.59 105.45C151.47 105.91 151.34 106.36 151.21 106.81V106.77C151.21 105.75 151.17 104.61 151.12 103.39C150.94 99.81 150.58 95.63 150.33 91.97C152.49 90.77 154.54 89.63 156.48 88.55Z"
        fill="#404040"
      />
      <Path
        d="M143.54 47.18C142.85 48.69 141.28 51.5 140.04 54.55C140.01 54.65 139.97 54.74 139.92 54.83C139.07 56.96 138.39 59.2 138.28 61.19C138.27 61.17 138.25 61.16 138.24 61.14C138.2 61.09 138.16 61.03 138.12 60.98C137.77 60.47 137.51 59.89 137.45 59.29C137.38 58.59 137.5 57.89 137.81 57.27C137.93 57.08 138.03 56.9 138.12 56.72C138.21 56.55 138.27 56.37 138.33 56.21C138.51 55.64 138.52 55.15 138.41 54.75C138.37 54.62 138.32 54.5 138.27 54.39C137.87 53.69 137.03 53.52 136.39 54.16C136.22 54.33 136.07 54.54 135.94 54.82C135.88 54.95 135.82 55.07 135.76 55.17C135.7 55.27 135.64 55.36 135.59 55.42C135.35 55.69 135.16 55.62 135.04 55.32C134.77 54.62 134.82 52.75 135.22 51.21C134.4 51.21 133.57 51.24 132.75 51.29C131.17 51.4 129.61 51.62 128.07 51.96C127.68 52.04 127.3 52.13 126.91 52.23C126.53 52.33 126.15 52.43 125.77 52.54C125.78 52.48 125.79 52.42 125.8 52.35C125.84 52.05 125.89 51.75 125.94 51.44C125.96 51.33 125.98 51.22 125.99 51.11C126.22 49.64 126.52 48.05 126.84 46.34C127.15 44.72 128.55 43.87 129.36 44.15C129.41 44.17 129.46 44.18 129.5 44.21C129.53 44.22 129.56 44.24 129.59 44.27C129.63 44.3 129.67 44.33 129.7 44.37C129.8 44.48 129.87 44.63 129.91 44.82C129.91 44.82 129.91 44.82 129.91 44.8C130.71 43.3 132.71 42.8 133.55 43.56C133.57 43.56 133.58 43.59 133.6 43.61C133.71 43.72 133.79 43.85 133.85 44C133.88 44.08 133.9 44.16 133.91 44.25C133.91 44.24 133.92 44.24 133.92 44.23C134.14 43.86 134.4 43.57 134.68 43.35C135.45 42.75 136.37 42.68 136.99 43C137.38 43.21 137.65 43.58 137.68 44.06C137.69 44.05 137.69 44.04 137.7 44.03C138.27 43.16 139.08 42.88 139.73 43.02C140 43.06 140.25 43.19 140.45 43.38C140.72 43.64 140.89 44.01 140.89 44.47C140.89 44.47 140.897 44.4633 140.91 44.45C141.29 44.09 141.68 43.84 142.07 43.71C142.49 43.56 142.9 43.55 143.24 43.69C143.4 43.75 143.55 43.85 143.67 43.99C144.16 44.52 144.25 45.59 143.53 47.18H143.54Z"
        fill="#404040"
      />
      <Path
        d="M121.99 156.66C122.7 158.77 123.46 161.08 124.24 163.48C127.04 160.16 135.14 152.29 138.06 149.66C132.96 152.15 127.38 154.55 121.99 156.67V156.66Z"
        fill="#404040"
      />
      <Path
        d="M134.25 64.32C134.03 64.87 133.76 65.4 133.43 65.9C132.7 67.09 131.73 68.12 130.58 68.93C130.59 68.88 130.6 68.84 130.6 68.79C130.77 67.77 130.87 66.73 130.89 65.7C130.94 65.68 130.99 65.67 131.04 65.65C131.85 65.38 132.65 65.06 133.44 64.71C133.7 64.59 133.97 64.46 134.25 64.32Z"
        fill="#404040"
      />
      <Path
        d="M128.17 199.63C122.66 212.69 110.86 223.69 106.2 226.61V226.58C106.4 223.23 106.83 219.91 107.45 216.63C107.48 216.45 107.51 216.27 107.55 216.1C107.61 215.81 107.67 215.51 107.73 215.22C108.52 211.47 109.57 207.77 110.9 204.16C111.1 204.14 111.31 204.11 111.51 204.07C111.71 204.04 111.92 204 112.13 203.96C112.22 203.95 112.31 203.93 112.4 203.91C112.57 203.88 112.75 203.84 112.93 203.8C113.17 203.75 113.42 203.69 113.66 203.63C113.83 203.59 114 203.54 114.17 203.49C114.26 203.47 114.35 203.45 114.45 203.41C114.64 203.36 114.84 203.31 115.03 203.24C115.29 203.16 115.55 203.08 115.81 202.99C116.03 202.91 116.26 202.83 116.48 202.74C116.65 202.69 116.82 202.62 116.99 202.55C117.04 202.53 117.09 202.51 117.14 202.48C117.28 202.43 117.42 202.37 117.56 202.31C117.64 202.28 117.72 202.25 117.8 202.2C117.93 202.15 118.07 202.09 118.2 202.02C118.61 201.84 119.02 201.64 119.41 201.42C119.5 201.38 119.59 201.33 119.68 201.27C119.88 201.16 120.09 201.05 120.28 200.92C120.49 200.81 120.69 200.68 120.89 200.55C121.11 200.42 121.32 200.27 121.53 200.12C122.43 199.49 123.24 198.8 123.94 198.05C124.13 197.86 124.31 197.66 124.47 197.46C124.69 197.2 124.89 196.93 125.08 196.66C126.18 197.51 127.19 198.47 128.08 199.53C128.13 199.56 128.15 199.58 128.15 199.61C128.18 199.62 128.19 199.62 128.17 199.63Z"
        fill="#404040"
      />
      <Path
        d="M113.42 107.95C112.76 108.27 112.09 108.59 111.42 108.89C110.74 109.2 110.07 109.5 109.39 109.8C108.93 110 108.46 110.2 108 110.4C107.39 110.66 106.78 110.92 106.16 111.17C105.64 111.38 105.11 111.58 104.59 111.79C104.4 111.86 104.21 111.94 104.02 112.01C103.33 112.27 102.65 112.53 101.96 112.78C100.29 113.41 98.6197 113.99 96.9297 114.53C96.9697 114.5 97.0097 114.48 97.0497 114.45C97.4097 114.21 97.7697 113.96 98.1297 113.71C98.9197 113.14 99.7197 112.53 100.51 111.89H100.52C101.32 111.25 102.1 110.59 102.87 109.91C103.25 109.57 103.64 109.22 104.02 108.89C106.27 106.84 108.33 104.75 109.95 103C109.94 102.99 109.95 102.99 109.95 102.99C110.23 102.71 110.48 102.43 110.72 102.16C111.1 101.75 111.43 101.37 111.73 101.03C112.02 100.69 112.29 100.37 112.52 100.1H112.53C112.6 100.68 112.66 101.29 112.73 101.92C112.8 102.54 112.87 103.19 112.95 103.85C113.1 105.17 113.26 106.55 113.43 107.95H113.42Z"
        fill="#404040"
      />
      <Path
        d="M71.93 86.83C71.93 86.93 71.92 87.03 71.91 87.14C71.9 87.24 71.88 87.35 71.87 87.46C71.85 87.67 71.81 87.9 71.76 88.14C71.75 88.14 71.75 88.14 71.74 88.14C71.65 88.1 71.55 88.06 71.46 88.02C71.36 87.97 71.25 87.92 71.15 87.87C71.05 87.82 70.95 87.76 70.86 87.7C70.57 87.53 70.29 87.31 70.02 87.04C69.88 86.9 69.75 86.75 69.62 86.59C69.62 86.59 69.61 86.58 69.61 86.57C69.55 86.49 69.49 86.4 69.43 86.31C69.37 86.22 69.32 86.13 69.27 86.04C69.4 85.86 69.53 85.69 69.67 85.55C69.77 85.44 69.88 85.35 69.99 85.28C70.1 85.19 70.22 85.12 70.33 85.06C70.4 85.03 70.47 85 70.54 84.97C70.76 84.89 70.98 84.87 71.17 84.92C71.23 84.94 71.3 84.96 71.36 85C71.75 85.22 71.99 85.81 71.93 86.84V86.83Z"
        fill="#404040"
      />
      <Path
        d="M65.5899 100.16C65.4599 100.3 65.3299 100.43 65.2099 100.55C65.0899 100.67 64.9799 100.78 64.8699 100.88C64.6499 101.08 64.4299 101.24 64.2399 101.34C64.0499 101.47 63.8699 101.54 63.7099 101.58C63.5299 101.63 63.3699 101.64 63.2299 101.62C63.1899 101.62 63.1699 101.61 63.1399 101.6C63.1399 101.6 63.1332 101.597 63.1199 101.59C63.0599 101.57 63.0099 101.55 62.9599 101.52C62.8499 101.45 62.7599 101.36 62.6899 101.23C62.6599 101.19 62.6299 101.14 62.6099 101.08C62.5499 100.95 62.5099 100.8 62.4799 100.64C62.3799 100.04 62.4799 99.25 62.7199 98.43C63.2099 98.71 63.6899 99 64.1699 99.29C64.6499 99.57 65.1299 99.87 65.5899 100.16Z"
        fill="#404040"
      />
      <Path
        d="M58.8198 96.13C58.8198 96.13 58.8098 96.12 58.7998 96.12"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.68 53.3L125.67 53.24"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M127.79 75.86L126.84 65.33"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.0401 89.88C54.5701 88.71 53.1401 88.17 51.9301 87.41C51.5101 87.1 51.2101 86.65 51.1101 86.14C51.0101 85.62 51.1101 85.09 51.3901 84.65C51.6701 84.21 52.1101 83.9 52.6201 83.77C53.1301 83.65 53.6701 83.72 54.1201 83.99C55.6401 84.77 56.9901 85.44 58.8701 86.5L58.8901 86.53C58.9901 86.59 59.0901 86.65 59.1701 86.7C59.1801 86.7 59.1901 86.72 59.1901 86.72C59.2901 86.79 59.3701 86.87 59.4501 86.94C59.6801 87.15 59.8401 87.38 59.9501 87.62C59.9801 87.7 60.0101 87.79 60.0401 87.87C60.4501 89.3 59.0301 90.82 57.0401 89.88Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M58.8701 86.5C58.9801 86.56 59.0801 86.63 59.1701 86.7C59.0901 86.65 58.9901 86.59 58.8901 86.53L58.8701 86.5V86.5Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.2201 77.7C59.7701 78.44 59.2801 79.61 58.5601 81.32C57.4601 80.8 56.3901 80.2 55.3801 79.52C54.9601 79.21 54.6801 78.74 54.5901 78.23C54.5101 77.71 54.6301 77.18 54.9301 76.75C55.2301 76.32 55.6801 76.03 56.2001 75.93C56.7101 75.83 57.2401 75.93 57.6801 76.22C58.3801 76.63 58.9401 76.95 59.5801 77.32C59.6801 77.38 59.7901 77.45 59.9001 77.51C59.9501 77.54 60.0101 77.57 60.0601 77.6C60.1101 77.64 60.1701 77.67 60.2201 77.7Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.2497 77.72C60.2497 77.72 60.2297 77.71 60.2197 77.7"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M58.7499 92.57C58.7299 92.64 58.7099 92.72 58.6799 92.79C58.6099 92.98 58.4999 93.16 58.3499 93.31C58.3299 93.34 58.3099 93.36 58.2899 93.38C58.0699 93.6 57.7899 93.76 57.4499 93.84C57.3999 93.86 57.3399 93.87 57.2799 93.88C57.2299 93.88 57.1799 93.9 57.1199 93.88C56.9999 93.9 56.8799 93.9 56.7499 93.88C56.6799 93.88 56.6099 93.86 56.5299 93.85C56.4699 93.84 56.4199 93.84 56.3699 93.82C56.2899 93.8 56.2199 93.78 56.1299 93.76C56.0399 93.72 55.9499 93.68 55.8499 93.64C55.5499 93.51 55.2699 93.39 54.9999 93.28C54.8599 93.21 54.7199 93.16 54.5899 93.1C54.2399 92.95 53.9099 92.81 53.5999 92.69C53.3699 92.59 53.1399 92.49 52.9299 92.41C52.1199 92.06 51.4599 91.76 50.8599 91.41C50.4399 91.13 50.1399 90.7 50.0299 90.2C49.9199 89.71 50.0099 89.19 50.2699 88.75C50.5399 88.32 50.9599 88 51.4499 87.88C51.9399 87.75 52.4599 87.81 52.9099 88.06C54.3599 88.75 55.6899 89.35 57.4899 90.3C57.4999 90.3 57.5199 90.32 57.5299 90.33L57.5599 90.35C57.7799 90.46 57.9599 90.59 58.1199 90.73C58.1999 90.8 58.2699 90.87 58.3299 90.94C58.7699 91.44 58.8799 92.04 58.7499 92.56V92.57Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.5598 90.35C57.7798 90.47 57.9598 90.59 58.1198 90.74C57.9598 90.6 57.7798 90.47 57.5598 90.36L57.5298 90.34C57.5298 90.34 57.5498 90.34 57.5598 90.35V90.35Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M58.5798 86.05C56.0898 84.81 54.6798 84.23 53.4498 83.42C53.0198 83.11 52.7198 82.64 52.6198 82.12C52.5298 81.59 52.6398 81.05 52.9398 80.6C53.2298 80.16 53.6898 79.85 54.2098 79.74C54.7298 79.62 55.2798 79.72 55.7298 80C56.6798 80.51 57.5398 80.9 58.5098 81.42C58.3398 81.84 58.1498 82.29 57.9398 82.78C57.3798 84.09 58.9298 85.45 61.0898 83.44C61.8098 84.89 60.6498 87.09 58.5798 86.05Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M71.74 88.13C71.44 89.56 70.74 91.5 69.46 94.03C67.94 97.04 66.64 98.99 65.59 100.16C65.13 99.86 64.65 99.56 64.17 99.29C63.69 98.99 63.2 98.7 62.72 98.43C61.33 97.63 59.97 96.87 58.82 96.13C58.88 93.98 59.9 91.69 61.57 88.57C61.55 88.5 61.53 88.42 61.51 88.35C61.27 87.48 61.18 86.57 61.24 85.67C61.25 85.48 61.27 85.29 61.3 85.11C61.3 85.07 61.3 85.03 61.31 84.99C61.32 84.95 61.33 84.91 61.33 84.87C61.33 84.86 61.34 84.84 61.34 84.83C61.35 84.73 61.37 84.64 61.39 84.55C61.41 84.43 61.44 84.31 61.47 84.2C61.47 84.15 61.49 84.09 61.51 84.03C61.54 83.94 61.57 83.84 61.6 83.74C61.65 83.58 61.71 83.41 61.78 83.23C61.83 83.1 61.88 82.98 61.94 82.85C61.95 82.83 61.97 82.8 61.98 82.77C62 82.72 62.02 82.66 62.05 82.61C62.08 82.54 62.11 82.47 62.16 82.4C62.3 82.14 62.45 81.89 62.61 81.65C62.57 81.7 62.54 81.76 62.5 81.81C62.46 81.87 62.42 81.92 62.37 81.98C62.48 81.77 62.61 81.56 62.74 81.35C62.17 82.27 61.61 82.95 61.09 83.44C58.93 85.45 57.38 84.09 57.94 82.78C58.15 82.29 58.34 81.84 58.51 81.42C58.53 81.39 58.54 81.35 58.56 81.32C59.28 79.61 59.77 78.44 60.22 77.7C60.29 77.58 60.36 77.5 60.42 77.41C60.49 77.32 60.55 77.24 60.62 77.17C60.67 77.11 60.73 77.05 60.79 77C60.93 76.88 61.07 76.8 61.22 76.74C61.29 76.71 61.36 76.69 61.43 76.68C61.51 76.67 61.58 76.66 61.66 76.66C61.89 76.66 62.15 76.71 62.44 76.81C62.54 76.84 62.64 76.88 62.75 76.92H62.76C63.08 77.05 63.44 77.21 63.86 77.41C63.99 77.48 64.13 77.55 64.28 77.62C64.48 77.72 64.67 77.81 64.85 77.9C64.85 77.91 64.87 77.91 64.88 77.91C64.97 77.95 65.06 77.99 65.14 78.04C65.22 78.08 65.3 78.12 65.38 78.16C65.46 78.2 65.53 78.24 65.6 78.27C65.68 78.3 65.75 78.34 65.82 78.38C65.87 78.41 65.92 78.43 65.97 78.46C66.06 78.51 66.14 78.56 66.22 78.6C66.3 78.64 66.38 78.68 66.45 78.73C66.63 78.83 66.78 78.94 66.92 79.04C66.99 79.09 67.06 79.14 67.11 79.19C67.17 79.25 67.22 79.3 67.27 79.35C67.4 79.48 67.5 79.61 67.59 79.76C67.85 80.19 67.94 80.74 68.03 81.59C68.06 81.87 68.08 82.14 68.13 82.4C68.14 82.4 68.14 82.39 68.15 82.39C68.37 84.04 68.77 85.2 69.25 86.03C69.31 86.13 69.37 86.22 69.43 86.3C69.49 86.39 69.55 86.48 69.61 86.56L69.62 86.58C69.75 86.75 69.89 86.89 70.02 87.03C70.29 87.3 70.57 87.52 70.86 87.69C70.95 87.76 71.05 87.82 71.15 87.86C71.25 87.91 71.36 87.96 71.46 88.01C71.55 88.05 71.65 88.09 71.74 88.13Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M65.59 100.16C65.46 100.3 65.33 100.43 65.21 100.55"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M64.87 100.88C64.64 101.07 64.44 101.22 64.24 101.34C64.05 101.45 63.87 101.53 63.71 101.58"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M63.1401 101.6C63.1401 101.6 63.1301 101.59 63.1201 101.59H63.1001C63.0501 101.57 63.0001 101.55 62.9601 101.52C62.8501 101.45 62.7601 101.36 62.6901 101.23C62.6501 101.18 62.6301 101.13 62.6101 101.08C62.5501 100.95 62.5101 100.8 62.4801 100.64C62.3701 100.04 62.4401 99.24 62.6901 98.43"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M69.25 86.03C69.38 85.84 69.52 85.68 69.67 85.54C69.77 85.43 69.88 85.34 69.99 85.27C70.1 85.18 70.22 85.11 70.33 85.05L70.54 84.96C70.77 84.88 70.98 84.87 71.17 84.91C71.23 84.93 71.3 84.95 71.36 84.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M71.8697 87.46C71.8397 87.67 71.7997 87.9 71.7397 88.13"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M61.4701 84.2C61.4301 84.32 61.4101 84.43 61.3901 84.55"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M61.34 84.82C61.34 84.82 61.34 84.85 61.34 84.87C61.1 86.1 61.18 87.28 61.52 88.35C61.81 89.3 62.32 90.17 62.99 90.9"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M62.3697 81.98C62.3697 81.98 62.3497 82.01 62.3497 82.03H62.3397C62.2697 82.16 62.2097 82.28 62.1597 82.4"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M62.7499 76.92C62.6399 76.87 62.5399 76.83 62.4399 76.81"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M67.1099 79.19C67.7699 79.74 67.9199 80.34 68.0499 81.59C68.0799 81.87 68.1099 82.14 68.1499 82.39"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M66.9197 79.04C66.7797 78.93 66.6297 78.83 66.4497 78.73"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M66.2197 78.6C66.1397 78.55 66.0597 78.5 65.9697 78.46"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M65.6001 78.27C65.4601 78.19 65.3001 78.11 65.1401 78.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M64.8801 77.91V77.9C64.7001 77.81 64.5101 77.72 64.3101 77.62C64.1601 77.55 64.0101 77.48 63.8701 77.41"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M71.1499 87.86C71.0499 87.81 70.9499 87.75 70.8599 87.69"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M191.54 25.16L191.87 25.22C192.01 25.25 192.14 25.28 192.27 25.32C193.34 25.64 194 26.25 193.86 26.89C193.86 26.89 193.86 26.91 193.85 26.92"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M193.66 27.3C193.61 27.37 193.55 27.44 193.47 27.51C193.09 27.87 192.42 28.21 191.41 28.5H191.39"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M177.97 28.8C176.22 28.36 175.48 27.7 175.46 27.11V27.08C175.46 26.49 176.22 25.92 177.41 25.73"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178.04 28.34C178.04 28.34 178.55 24.8 173.03 21.77C173.03 21.77 171.61 16.09 173.79 14.04L180.2 14.12C180.2 14.12 183.42 14.64 179.98 16.81L185.28 13.96H188.49L190.4 15.21L191.52 18.42L191.45 28.09C191.45 28.09 184.52 31.29 178.05 28.34H178.04Z"
        fill="#F5F5F5"
      />
      <Path
        d="M186.76 16.13C186.52 19.1 182.92 19.2 182.94 16.32C182.94 14.19 183.04 12.67 183.13 10.96C183.28 8.11 187.08 8.13 187.16 10.48C187.22 11.91 186.98 13.4 186.76 16.13Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M174.67 13.97V13.96"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M191.39 11.37C191.39 11.55 191.38 11.74 191.38 11.93C191.32 13.15 191.08 14.54 190.85 16.82C190.55 19.72 187.06 19.72 187.17 16.92C187.25 14.85 187.38 13.38 187.5 11.74C187.71 8.99 191.39 9.1 191.39 11.37Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178.74 14.06V14.05"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M182.7 16.07C182.71 16.48 182.59 16.89 182.35 17.23C182.11 17.56 181.76 17.82 181.37 17.94C180.97 18.07 180.55 18.08 180.16 17.94C179.78 17.8 179.51 17.57 179.16 17.19C181.99 16.13 181.63 14.18 180.21 14.12C179.68 14.09 179.19 14.07 178.74 14.05C178.76 12.93 178.85 11.95 178.88 10.89C178.94 7.99 182.81 7.94 182.96 10.32C183.05 11.76 182.84 13.28 182.7 16.07Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M179.19 17.19C178.52 17.45 177.67 17.69 176.6 17.8C180.87 17.32 183.79 19.27 184.72 22.14"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178.64 14.04C176.79 13.94 175.53 13.87 174.67 13.96C174.64 12.92 174.67 12.14 174.65 11.15C174.61 8.43999 178.46 8.31999 178.64 10.58C178.72 11.73 178.72 12.89 178.64 14.04Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178 28.82C178.11 27.86 178.1 26.85 177.43 25.73C176.89 24.8 175.9 23.78 174.17 22.67C172.34 21.48 172.37 21.12 172.61 17.58C172.78 15 172.95 14.15 174.7 13.96"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178.74 14.05C178.74 14.05 178.67 14.04 178.64 14.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M191.4 28.51C191.26 23.62 191.74 15.73 191.36 11.93"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M143.09 68.28C139.97 79.52 127.91 81.83 124.78 78.58C124.78 78.57 124.79 78.57 124.79 78.57C125.99 77.78 126.98 76.78 127.77 75.67C129.29 73.55 130.14 71.03 130.54 68.83C130.56 68.82 130.58 68.81 130.6 68.79C130.6 68.84 130.59 68.88 130.58 68.93C131.73 68.12 132.7 67.09 133.43 65.9C133.78 65.4 134.07 64.86 134.3 64.3C134.28 64.31 134.27 64.32 134.25 64.32C133.97 64.46 133.7 64.59 133.44 64.71C132.65 65.06 131.85 65.38 131.04 65.65C130.99 65.67 130.93 65.69 130.89 65.7H130.87C129.14 66.22 127.81 66.19 126.86 65.51C125.03 64.21 124.65 60.42 125.67 53.24V53.22C125.7 53 125.73 52.77 125.77 52.54C126.15 52.43 126.53 52.33 126.91 52.23C127.3 52.13 127.68 52.04 128.07 51.96C128.45 51.88 128.84 51.8 129.23 51.73C130.39 51.53 131.57 51.38 132.75 51.29C133.57 51.24 134.4 51.21 135.22 51.21C134.82 52.75 134.77 54.62 135.04 55.32C135.13 55.59 135.28 55.69 135.48 55.52C135.51 55.5 135.55 55.47 135.59 55.42C135.64 55.36 135.7 55.27 135.76 55.17C135.82 55.07 135.88 54.95 135.94 54.82C136.07 54.54 136.22 54.33 136.39 54.16C136.98 53.57 137.74 53.67 138.18 54.23C138.21 54.28 138.24 54.33 138.27 54.38C138.33 54.5 138.38 54.62 138.41 54.75C138.44 54.83 138.45 54.92 138.46 55.01C138.47 55.1 138.48 55.19 138.48 55.29V55.31C138.48 55.44 138.48 55.58 138.45 55.73C138.42 55.88 138.39 56.04 138.33 56.21C138.27 56.37 138.2 56.55 138.12 56.72C138.03 56.9 137.93 57.08 137.81 57.27C137.5 57.89 137.37 58.59 137.44 59.29C137.5 59.89 137.76 60.47 138.12 60.98C138.16 61.03 138.2 61.09 138.24 61.14C138.15 62.7 138.4 64.15 139.18 65.4C140.1 66.87 141.44 67.83 143.09 68.28Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M130.54 68.83L130.42 68.92"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M133.43 65.9C132.68 67.02 131.69 68.01 130.6 68.79"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M133.44 64.71C132.57 65.11 131.77 65.43 131.04 65.65"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.77 52.54C125.78 52.48 125.79 52.42 125.8 52.35C125.84 52.05 125.89 51.75 125.94 51.44C125.96 51.33 125.98 51.22 125.99 51.11C126.23 49.64 126.52 48.06 126.86 46.34C127.17 44.75 128.55 43.9 129.36 44.15C129.41 44.17 129.46 44.18 129.5 44.21C129.53 44.22 129.56 44.24 129.59 44.27C129.63 44.29 129.67 44.32 129.7 44.37C129.81 44.47 129.88 44.61 129.92 44.8C129.92 44.8 129.923 44.8067 129.93 44.82C130.72 43.33 132.71 42.82 133.56 43.56C133.58 43.56 133.59 43.59 133.61 43.61C133.72 43.71 133.81 43.84 133.86 44C133.9 44.07 133.92 44.15 133.93 44.23C133.93 44.23 133.933 44.2367 133.94 44.25C134.15 43.88 134.41 43.58 134.69 43.35C135.46 42.75 136.38 42.68 137 43C137.39 43.2 137.67 43.56 137.71 44.03C137.72 44.04 137.72 44.05 137.72 44.06C138.28 43.18 139.08 42.89 139.74 43.02C140.01 43.06 140.26 43.19 140.46 43.38C140.74 43.62 140.91 43.99 140.92 44.45V44.47C141.29 44.1 141.69 43.85 142.08 43.71C142.5 43.56 142.91 43.55 143.25 43.69C143.41 43.74 143.56 43.84 143.68 43.99C144.18 44.5 144.28 45.57 143.56 47.18C142.66 49.18 141.21 51.81 140.04 54.55C140.01 54.65 139.97 54.74 139.92 54.83C139.05 56.95 138.36 59.13 138.24 61.14"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.46 27.36V27.11"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M192.46 65.32C190.26 69.43 186.06 72.08 156.49 88.55H156.48C154.54 89.63 152.49 90.77 150.33 91.97C150.36 92.43 150.4 92.89 150.43 93.36C150.6 95.72 150.8 98.23 150.96 100.61C151.02 101.56 151.07 102.49 151.12 103.39C151.17 104.61 151.21 105.75 151.21 106.77C150.46 109.42 149.77 111.84 149.24 113.69C148.45 113.69 147.68 113.71 146.91 113.75C146.39 113.77 145.86 113.79 145.34 113.82C144.31 113.88 143.29 113.95 142.29 114.06C141.78 114.1 141.28 114.16 140.78 114.22C140.53 114.24 140.28 114.27 140.04 114.31C139.37 114.39 138.71 114.49 138.05 114.6C138.01 114.6 137.97 114.6 137.93 114.62C137.38 114.7 136.84 114.79 136.3 114.9C136.03 114.94 135.77 114.99 135.51 115.05C135.01 115.14 134.52 115.25 134.03 115.36C133.83 115.4 133.63 115.44 133.44 115.49C132.88 115.62 132.32 115.76 131.78 115.91C131.32 116.02 130.87 116.14 130.43 116.27C129.89 116.42 129.35 116.58 128.82 116.76C128.65 116.8 128.49 116.85 128.33 116.91C127.74 117.1 127.16 117.29 126.59 117.5C126.12 117.66 125.67 117.83 125.22 118.01C124.88 118.13 124.54 118.27 124.2 118.41C123.51 118.68 122.83 118.97 122.16 119.28C121.82 119.42 121.48 119.58 121.15 119.75C120.81 119.89 120.48 120.05 120.15 120.23C118.45 121.06 116.79 121.97 115.19 122.96C114.7 118.69 114.03 113.14 113.41 107.95C113.37 107.6 113.33 107.25 113.28 106.9C113.16 105.86 113.04 104.84 112.93 103.85C112.85 103.19 112.78 102.54 112.71 101.92C112.64 101.29 112.58 100.68 112.51 100.09H112.5C112.27 100.37 112 100.69 111.71 101.03C111.4 101.37 111.07 101.75 110.7 102.15C110.45 102.42 110.2 102.7 109.93 102.99C109.73 103.22 109.52 103.44 109.3 103.67C108.65 104.35 107.95 105.07 107.2 105.83C106.7 106.31 106.19 106.82 105.65 107.35C105.12 107.85 104.56 108.37 104 108.89C103.62 109.22 103.23 109.57 102.85 109.91C102.08 110.58 101.29 111.24 100.5 111.89H100.49C99.6999 112.52 98.9099 113.13 98.1099 113.71C97.7499 113.96 97.3899 114.21 97.0299 114.45C96.2999 114.68 95.5699 114.9 94.8399 115.12C89.2099 116.67 85.5999 115.2 63.1299 101.6C63.1599 101.61 63.1799 101.62 63.2199 101.62C63.3599 101.64 63.5199 101.63 63.6999 101.58C63.8599 101.54 64.0399 101.47 64.2299 101.34C64.4199 101.24 64.6399 101.08 64.8599 100.88C64.9699 100.78 65.0799 100.67 65.1999 100.55C65.3199 100.44 65.4499 100.31 65.5799 100.16C66.6299 98.99 67.9299 97.04 69.4499 94.03C70.7299 91.5 71.4299 89.56 71.7299 88.13C71.7399 88.13 71.7399 88.13 71.7499 88.13C71.7999 87.89 71.8399 87.66 71.8599 87.45C71.8699 87.34 71.8899 87.23 71.8999 87.13C71.8999 87.02 71.9199 86.92 71.9199 86.82C71.9799 85.79 71.7399 85.2 71.3499 84.98C76.3699 87.99 82.5399 91.06 86.6799 93.03C88.9999 94.15 90.6899 94.92 91.1599 95.14C97.0999 92.72 116.72 83.87 124.77 78.57C127.9 81.82 139.96 79.51 143.08 68.27C145.51 68.93 148.61 68.49 152.03 66.9C158.37 63.96 173.17 56.57 175.04 55.34C175.44 48.33 175.49 33.45 175.45 27.35C175.62 27.87 176.38 28.44 177.96 28.83V28.79C177.96 28.79 177.98 28.8 177.99 28.8C179.37 29.14 181.39 29.36 184.19 29.31C187.52 29.24 189.85 28.93 191.38 28.49V28.52C192.16 28.29 192.73 28.04 193.12 27.77C193.26 27.68 193.37 27.59 193.46 27.5C193.55 27.43 193.61 27.36 193.65 27.29C193.7 27.23 193.74 27.17 193.77 27.11C193.8 27.04 193.83 26.98 193.84 26.91C193.84 60.32 194.22 62.01 192.45 65.31L192.46 65.32Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M151.21 106.84V106.77"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M150.33 91.97C150.6 95.62 150.95 99.81 151.12 103.39"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M193.85 26.92V26.86"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M130.87 65.68V65.7C130.86 66.58 130.77 67.66 130.54 68.83"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M143.1 68.25C143.1 68.25 143.09 68.27 143.09 68.28"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M124.78 78.58L124.76 78.56"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M138.28 61.19C138.28 61.19 138.25 61.16 138.24 61.14"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M138.12 56.72C138.21 56.55 138.27 56.37 138.33 56.21C138.58 55.46 138.51 54.83 138.27 54.39"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M136.39 54.16C137.03 53.49 137.88 53.67 138.27 54.38"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M135.94 54.82C135.88 54.95 135.82 55.07 135.76 55.17"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M156.49 88.55C155.93 90.41 155.2 92.93 154.39 95.7C154.38 95.73 154.37 95.76 154.37 95.78C154.28 96.07 154.2 96.35 154.12 96.63C153.82 97.69 153.51 98.77 153.19 99.85C152.99 100.57 152.78 101.29 152.58 102C152.34 102.8 152.12 103.59 151.9 104.38C151.79 104.74 151.69 105.1 151.59 105.45C151.46 105.89 151.34 106.33 151.21 106.77"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M149.24 113.69C153.06 120.34 154.3 126.18 153.99 131.04V131.08C153.94 131.97 153.83 132.83 153.67 133.65C153.55 134.3 153.39 134.94 153.22 135.55C153.16 135.74 153.1 135.93 153.04 136.11C152.98 136.31 152.91 136.5 152.84 136.69C152.78 136.88 152.71 137.06 152.63 137.24C152.56 137.43 152.49 137.61 152.4 137.79C152.33 137.97 152.25 138.15 152.16 138.32C152.01 138.67 151.84 139 151.65 139.33C151.41 139.79 151.14 140.23 150.86 140.65C150.74 140.83 150.62 141.01 150.48 141.19C150.28 141.48 150.06 141.76 149.84 142.03C149.51 142.44 149.17 142.82 148.81 143.17C148.01 144 147.15 144.71 146.27 145.28C146.25 145.28 146.22 145.31 146.19 145.32C146.05 145.42 145.9 145.51 145.75 145.6C143.41 146.97 140.82 148.33 138.1 149.66C138.08 149.67 138.06 149.67 138.04 149.69C137.75 149.83 137.45 149.97 137.15 150.12C136.82 150.28 136.48 150.44 136.14 150.59C136.13 150.6 136.11 150.61 136.09 150.62C135.46 150.92 134.82 151.22 134.17 151.51C133.5 151.82 132.83 152.12 132.14 152.43C130.81 153.02 129.46 153.6 128.11 154.17C126.76 154.75 125.39 155.31 124.03 155.86C123.36 156.14 122.69 156.41 122.02 156.67C122.02 156.67 122.013 156.67 122 156.67C121.88 156.73 121.76 156.77 121.65 156.81C118.45 158.09 115.34 159.27 112.45 160.34C111.4 160.73 110.39 161.1 109.41 161.46C108.13 161.92 106.91 162.36 105.77 162.77"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M127.46 123.36C87.6497 141.08 80.6797 145.12 79.4397 152.55C78.3797 158.89 81.0797 165.26 104.64 203.93C111.2 205.71 123.5 201.75 126.21 194.55C119.13 180.17 111.77 165.67 109.42 161.47"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M146.26 145.24V145.26C146.26 145.26 146.27 145.27 146.27 145.28C147.27 150.71 149.87 162.57 151.51 170.15C154.61 170.44 168.29 170.72 177.75 171.17C178.52 171.21 179.26 171.25 179.97 171.29C179.97 171.3 179.97 171.31 179.99 171.32C180.01 171.35 180.03 171.39 180.05 171.43C180.4 172.01 180.72 172.66 180.99 173.36"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M181 173.38C181 173.38 181.02 173.42 181.02 173.44C181.16 173.77 181.28 174.11 181.4 174.47C181.5 174.78 181.6 175.11 181.69 175.44C181.75 175.67 181.81 175.89 181.86 176.12C181.97 176.57 182.06 177.03 182.15 177.5C182.2 177.76 182.24 178.03 182.29 178.3C182.47 179.46 182.58 180.65 182.63 181.84C182.77 185.08 182.42 188.24 181.6 190.44C181.55 190.58 181.5 190.72 181.44 190.85C181.44 190.86 181.43 190.88 181.42 190.89C181.03 191.82 180.55 192.54 179.97 192.98C177.15 192.97 174.54 192.96 172.13 192.95C171.08 192.94 170.06 192.93 169.09 192.93C159.97 192.85 153.88 192.72 149.58 192.47C149.16 192.44 148.76 192.42 148.38 192.39C147.8 192.35 147.26 192.31 146.75 192.26C146.73 192.26 146.7 192.26 146.68 192.25C146.25 192.22 145.84 192.18 145.45 192.13C145.06 192.09 144.7 192.04 144.35 191.99C144.15 191.97 143.95 191.94 143.77 191.91C143.56 191.88 143.36 191.85 143.17 191.81C142.96 191.78 142.76 191.74 142.56 191.7C142.53 191.7 142.49 191.69 142.46 191.68C142.23 191.64 142.01 191.59 141.79 191.54C141.28 191.42 140.81 191.3 140.36 191.16L139.88 191.01C139.59 190.91 139.3 190.81 139.02 190.7L138.36 190.43C138.26 190.39 138.16 190.34 138.05 190.3C137.66 190.13 137.26 189.94 136.84 189.75C136.75 189.71 136.66 189.66 136.58 189.62C136.22 189.42 135.87 189.16 135.52 188.85C135.27 188.62 135.01 188.35 134.76 188.07C134.41 187.67 134.07 187.23 133.73 186.75C130.29 181.79 127.1 172.1 124.28 163.48C124.28 163.47 124.27 163.46 124.27 163.45C123.49 161.07 122.74 158.77 122.02 156.67"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M129.64 201.34C126.79 209.29 115.52 224.35 106.25 230.07C106.16 229.07 106.15 227.9 106.2 226.61C110.86 223.69 122.66 212.69 128.17 199.63C128.7 200.18 129.18 200.75 129.64 201.34Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M110.88 204.16C109.66 207.24 108.56 211.2 107.73 215.22C107.66 215.51 107.6 215.8 107.55 216.1C107.51 216.27 107.48 216.45 107.45 216.63C106.77 220.17 106.32 223.68 106.2 226.58V226.61"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M128.17 199.63C128.17 199.63 128.18 199.63 128.15 199.61C128.15 199.58 128.13 199.56 128.08 199.53C127.16 198.51 126.15 197.55 125.08 196.66"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M172.6 170.98C175.73 174.49 177.28 186.49 172.12 192.95"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M100.36 196.89C107.58 198.48 118.98 195.58 122.64 187.34"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M106.15 226.61C110.76 223.71 122.63 212.69 128.14 199.61"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M200.66 202.1C200.03 202.01 199.37 201.88 198.69 201.69C198.66 201.07 198.59 200.43 198.49 199.78C198.38 199.13 198.24 198.46 198.07 197.79C197.98 197.45 197.89 197.11 197.79 196.76C196.18 191.28 192.66 185.24 189.3 180.52C188.88 179.93 188.46 179.36 188.05 178.81C187.64 178.27 187.24 177.75 186.84 177.25C186.45 176.76 186.06 176.29 185.69 175.86C184.76 174.78 183.93 173.89 183.25 173.26C182.5 173.26 181.74 173.28 181 173.38C181 173.38 180.996 173.373 180.99 173.36C182.42 173.19 183.86 173.19 185.29 173.36C189.3 176.61 200.51 190.06 200.66 202.1Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M181.49 190.74C181.49 190.74 181.5 190.75 181.5 190.76C183.54 193.46 188.37 197.11 193.27 199.56C194.51 200.18 195.75 200.72 196.95 201.15L197.49 201.33C197.89 201.47 198.29 201.59 198.69 201.69"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M198.49 199.78C198.38 199.13 198.24 198.46 198.07 197.79"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M189.3 180.52C192.66 185.23 196.17 191.27 197.79 196.76"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M188.05 178.81C187.64 178.27 187.23 177.75 186.84 177.25C186.44 176.76 186.06 176.29 185.69 175.86"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M115.77 128.59C115.66 127.28 115.45 125.31 115.19 122.96"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M113.41 107.95C113.25 106.55 113.09 105.17 112.94 103.85"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M112.72 101.92C112.64 101.29 112.58 100.69 112.51 100.1C112.3 98.15 112.13 96.46 112.02 95.15"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M115.19 122.96C115.19 122.96 115.16 122.97 115.15 122.98"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M128.33 116.91C127.74 117.1 127.16 117.29 126.59 117.5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M130.43 116.27C129.89 116.42 129.35 116.58 128.82 116.76"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M136.3 114.9C136.03 114.94 135.77 114.99 135.51 115.05"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M149.27 113.69H149.24"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M114.7 195.02C109.52 184.97 98.79 162.06 96.48 157.26C107.22 151.84 134.5 140.49 139.21 137.57C143.91 134.65 145.76 130.9 140.78 114.22"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M113.41 107.95C112.75 108.27 112.08 108.59 111.41 108.89C110.74 109.2 110.06 109.51 109.38 109.8C108.92 110.01 108.46 110.21 107.99 110.4C107.38 110.66 106.77 110.92 106.15 111.17C105.63 111.38 105.1 111.58 104.58 111.79C104.39 111.86 104.2 111.94 104.01 112.01C103.32 112.27 102.64 112.53 101.95 112.78C100.32 113.37 98.69 113.93 97.04 114.45"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M63.1201 101.59C63.1201 101.59 63.1201 101.6 63.1401 101.6"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M97.0399 114.45C97.0399 114.45 96.9599 114.5 96.9199 114.53"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M124.27 163.48C127.07 160.16 135.17 152.32 138.09 149.66"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M47.6104 188.46C51.5604 188.46 54.7604 185.26 54.7604 181.31C54.7604 177.36 51.5604 174.16 47.6104 174.16C43.6604 174.16 40.4604 177.36 40.4604 181.31C40.4604 185.26 43.6604 188.46 47.6104 188.46Z"
        fill="#404040"
      />
      <Path
        d="M57.4202 208.51C65.1602 208.51 71.4302 202.24 71.4302 194.5C71.4302 186.76 65.1602 180.49 57.4202 180.49C49.6802 180.49 43.4102 186.76 43.4102 194.5C43.4102 202.24 49.6802 208.51 57.4202 208.51Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M210.25 55.37C212.64 55.37 214.57 53.43 214.57 51.05C214.57 48.67 212.64 46.73 210.25 46.73C207.86 46.73 205.93 48.67 205.93 51.05C205.93 53.43 207.86 55.37 210.25 55.37Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M42.3804 127.35C43.6004 127.35 44.5904 126.36 44.5904 125.14C44.5904 123.92 43.6004 122.93 42.3804 122.93C41.1604 122.93 40.1704 123.92 40.1704 125.14C40.1704 126.36 41.1604 127.35 42.3804 127.35Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M155.34 18.86L153.13 27.7L159.83 26.51L157.62 35.35"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M33.9302 59.14L34.7502 63.8"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M44.5902 66.6L39.9302 67.42"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M37.1301 77.27L36.3101 72.61"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.4702 69.81L31.1302 68.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M39.9301 67.43C39.3501 67.53 38.7601 67.52 38.1901 67.39C37.6201 67.26 37.0701 67.02 36.5901 66.69C36.1101 66.35 35.7001 65.92 35.3801 65.43C35.0601 64.93 34.8501 64.38 34.7501 63.8C34.8501 64.38 34.8401 64.97 34.7101 65.55C34.5801 66.12 34.3501 66.67 34.0101 67.15C33.6701 67.63 33.2401 68.04 32.7501 68.36C32.2501 68.68 31.7001 68.89 31.1201 68.99C31.7001 68.89 32.2901 68.9 32.8601 69.03C33.4301 69.16 33.9801 69.4 34.4601 69.73C34.9401 70.07 35.3501 70.5 35.6701 70.99C35.9901 71.49 36.2001 72.04 36.3001 72.62C36.2001 72.04 36.2101 71.45 36.3401 70.88C36.4701 70.31 36.7001 69.76 37.0401 69.28C37.3801 68.8 37.8001 68.39 38.3001 68.07C38.8001 67.75 39.3501 67.54 39.9301 67.44V67.43Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M210.22 129.63L211.4 136.31"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M225.51 140.33L218.83 141.51"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M214.82 155.62L213.64 148.94"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M199.53 144.92L206.21 143.74"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M218.83 141.51C218 141.66 217.15 141.64 216.33 141.46C215.51 141.28 214.73 140.94 214.04 140.45C213.35 139.97 212.76 139.35 212.31 138.64C211.86 137.93 211.55 137.14 211.4 136.31C211.55 137.14 211.53 137.99 211.35 138.81C211.17 139.63 210.83 140.41 210.34 141.1C209.86 141.79 209.24 142.38 208.53 142.83C207.82 143.28 207.03 143.59 206.2 143.74C207.03 143.59 207.88 143.61 208.7 143.79C209.52 143.97 210.3 144.31 210.99 144.8C211.68 145.28 212.27 145.9 212.72 146.61C213.17 147.32 213.48 148.11 213.62 148.94C213.47 148.11 213.49 147.26 213.67 146.44C213.85 145.62 214.19 144.84 214.68 144.15C215.16 143.46 215.78 142.87 216.49 142.42C217.2 141.97 217.99 141.66 218.82 141.51H218.83Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_8483_162755">
        <Rect width={199.98} height={238.44} fill="white" transform="translate(26 6)" />
      </ClipPath>
    </Defs>
  </Svg>
)

export const EmailConfirmed = memo(EmailConfirmedIllustration)
